import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Container, Typography } from '@material-ui/core';
import SpinnerComponent from '../../../components/SpinnerComponent';
import PdfCard from './PdfCard';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2.5),
    margin: theme.spacing(3, 0),
  },
  cardContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2.5),
  },
  placeholder: {
    padding: theme.spacing(2),
    fontStyle: 'italic',
  },
}));

const PdfList = (props) => {
  const classes = useStyles();

  return (
    <Container maxWidth="md" className={classes.root}>
      <Typography variant="h6">PDF caricati</Typography>
      <div className={classes.cardContainer}>
        {props.loading ? (
          <SpinnerComponent size={32} />
        ) : props.files.length === 0 ? (
          <Typography className={classes.placeholder} color="textSecondary">
            Nessun PDF caricato
          </Typography>
        ) : (
          props.files.map((item) => (
            <PdfCard
              key={item.id}
              pdfAttachment={item}
              index={item.posizione}
              onRemoveAttachment={props.onRemoveAttachment}
              onViewPdf={props.onViewPdf}
            />
          ))
        )}
      </div>
    </Container>
  );
};

PdfList.propTypes = {
  loading: PropTypes.bool,
  files: PropTypes.array,
  onRemoveAttachment: PropTypes.func,
  onViewPdf: PropTypes.func,
};

PdfList.defaultProps = {
  files: [],
};

export default PdfList;
